import { isEditing } from "@builder.io/sdk-react";
import type { RegisteredComponent } from "@builder.io/sdk-react";

import { createProductCarouselOptionsSchema } from "~/hec/builder/carousel-options/carousel-options.schemas";
import { useBuilderOptions } from "~/hec/builder/carousel-options/use-builder-options";
import { ProductCategoryCarousel } from "~/hec/components/product-category-carousel";

import { productCarouselInputs } from "./inputs";
import type { ProductCarouselBlockProps } from "./types";

const ProductCarouselBlock = ({
  addedToCartPodId,
  ButtonNavigationColor,
  enableNavigationArrows,
  showNavigationArrowsMobile,
  showNavigationArrowsDesktop,
  enableHeadline = false,
  headlineText,
  ctaText,
  ctaHref,
  enableBasicView = true,
  productTileBorderColor,
  attributes,
  builderBlock,
  ...stored
}: ProductCarouselBlockProps) => {
  const { categoryId, ...layout } = useBuilderOptions(
    createProductCarouselOptionsSchema,
    stored,
    builderBlock,
  );
  // In the editor the carousel shows a "Category: (none set)" placeholder.
  if (!categoryId && !isEditing()) return null;

  return (
    <div {...(attributes ?? {})}>
      <ProductCategoryCarousel
        categoryId={categoryId ?? ""}
        {...layout}
        addedToCartPodId={addedToCartPodId}
        ButtonNavigationColor={ButtonNavigationColor}
        enableNavigationArrows={enableNavigationArrows}
        showNavigationArrowsMobile={showNavigationArrowsMobile}
        showNavigationArrowsDesktop={showNavigationArrowsDesktop}
        enableHeadline={enableHeadline}
        headlineText={headlineText}
        ctaText={ctaText}
        ctaHref={ctaHref}
        enableBasicView={enableBasicView}
        productTileBorderColor={productTileBorderColor}
      />
    </div>
  );
};

export const ProductCarouselDefinition = {
  component: ProductCarouselBlock,
  name: "ProductCarousel",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  inputs: productCarouselInputs,
} satisfies RegisteredComponent;
